module.exports = __webpack_public_path__ + "static/Hospitality-Photo1-4e0506584241f5fb8084dc31b429ae11.png";